import { wpApi, wcApi } from "./axios";

export async function loginUser(username, password) {
    const response = await wpApi.post("/jwt-auth/v1/token", {
        username,
        password,
    });
    return response.data;
}

export async function validateToken() {
    const response = await wpApi.post("/jwt-auth/v1/token/validate");
    return response.data;
}

export async function registerUser({ firstName, lastName, email, password }) {
    const response = await wpApi.post("/headless/v1/register", {
        first_name: firstName,
        last_name: lastName,
        email,
        password,
    });
    return response.data;
}

export async function getCurrentCustomer() {
    const response = await wpApi.get("/wc/v3/customers/me");
    return response.data;
}

export async function updateCustomer(customerId, data) {
    const response = await wpApi.put(`/wc/v3/customers/${customerId}`, data);
    return response.data;
}
